var render, staticRenderFns
import script from "./indexType.vue?vue&type=script&lang=js"
export * from "./indexType.vue?vue&type=script&lang=js"
import style0 from "./indexType.vue?vue&type=style&index=0&id=af0472c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0472c4",
  null
  
)

export default component.exports